module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc25a-fad482b60a40a0118f01966810436674.jpg";